import { Pipe, PipeTransform } from "@angular/core";
import { DocumentUtil } from "@gipi-ui/utils/document.util";
import { StringUtil } from "@gipi-ui/utils/string.util";

@Pipe({ name: "GIPICpfCnpj" })
export class CpfCnpjPipe implements PipeTransform {
    /**
     * Formata um CPF/CNPJ ou retorna seu valor passado caso inválido.
     * O CPF/CNPJ informado deve ser composto por 11 ou 14 caracteres
     * numéricos respectivamente.
     *
     * @param string cpfCnpj
     * @return string
     */
    transform(value: string): string {
        if (StringUtil.isEmpty(value)) {
            return "";
        }

        var cleared = DocumentUtil.clearFormat(value);
        if (cleared.length === 11) {
            value = DocumentUtil.formatCpf(cleared);
        } else if (cleared.length === 14) {
            value = DocumentUtil.formatCnpj(cleared);
        }
        return value;
    }
}
